import type { FC } from "react";

import { ContractProfilesSearchForm } from "src/app/features/ContractProfile/components/forms/ContractProfilesSearchForm";
import { ContractProfilesTable } from "src/app/features/ContractProfile/components/tables/ContractProfilesTable";
import type { ContractProfileList } from "src/app/features/ContractProfile/types/ContractProfileList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const ContractProfilesPage: FC<NoneOwnProps> = () => {
    const table = <ContractProfilesTable />;
    const searchForm = <ContractProfilesSearchForm />;
    const hasAccess = canAccess(ResourceName.CONTRACT_PROFILES, "canRead");

    return (
        <PageLayout name="contractProfiles_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.contractProfiles" />
                    <ResourceManager<ContractProfileList>
                        useDataGroup
                        dataMapperKey="contractProfilesTableData"
                        resource={ResourceName.CONTRACT_PROFILES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.EXPORT, Actions.COPY]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
